import { theme } from '../theme';
import Dashboard from './Dashboard';
import { useIsMobile } from '../hooks/useMediaQuery';

const FEATURES = [
  {
    title: 'Administración de Productos',
    content: 'Gestiona tu catálogo de productos directamente desde la plataforma. Agrega, edita o elimina productos, define precios, stock y descripciones.',
  },
  {
    title: 'Pedidos en Cola',
    content: 'Lleva un control ordenado de todos los pedidos recibidos a través de tu página. Visualiza la cola de pedidos en tiempo real, asigna prioridades y mantén a tu equipo sincronizado para una gestión eficiente.',
  },
  {
    title: 'Despacho de Mercancía',
    content: 'Cierra el ciclo completo de venta desde la plataforma. Gestiona el despacho de mercancía, actualiza el estado de los pedidos y notifica automáticamente a tus clientes sobre el envío de su compra.',
  }
];

function Home({ user, token, roleId }) {
  const isMobile = useIsMobile();
  // Usuarios logueados (empresa: roles 1, 2 y 3) ven su panel de métricas.
  // Visitantes sin sesión ven la página de presentación con planes y tarifas.
  if (user && [1, 2, 3].includes(roleId)) {
    return <Dashboard token={token} username={user} />;
  }

  return (
    <main style={{ padding: '3rem 1.5rem', maxWidth: isMobile ? '860px' : '1180px', margin: '0 auto' }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: 'clamp(1.25rem, 5vw, 2.5rem)',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
        marginBottom: '2rem',
      }}>
        <img src="/logo_principal.jpg" alt="Logo" style={{ width: '100%', maxWidth: '480px', height: 'auto', objectFit: 'contain', display: 'block', margin: '0 auto 1rem' }} />
        <p style={{ color: theme.colors.textMuted, textAlign: 'center', marginBottom: '0.5rem', fontSize: '1rem' }}>
          🚀 Impulsamos tu negocio hacia su siguiente etapa
        </p>
        <div style={{
          width: '60px',
          height: '3px',
          backgroundColor: theme.colors.primary,
          margin: '0 auto 2.5rem',
          borderRadius: '2px',
        }} />

        <p style={{ color: theme.colors.text, lineHeight: '1.8', fontSize: '1rem', marginBottom: '2.5rem', textAlign: 'center', maxWidth: isMobile ? 'none' : '760px', marginLeft: 'auto', marginRight: 'auto' }}>
          Somos una empresa dedicada a <strong style={{ color: theme.colors.primary }}>emprender contigo</strong> 🌱 y a llevar tu negocio
          a nuevas etapas de crecimiento. Te damos las herramientas para que vendas más, organices tu operación
          y construyas presencia digital, todo desde un solo lugar. ✨ Ya sea con tu propia <strong style={{ color: theme.colors.primary }}>página web</strong> 🌐
           que atiende a tus clientes 24/7,
          tenemos un plan a la medida de tu emprendimiento. 💪
        </p>

      <div style={{
        background: `linear-gradient(135deg, ${theme.colors.primary}, rgba(56, 189, 248, 0.65))`,
        borderRadius: '16px',
        padding: 'clamp(1.5rem, 6vw, 2.5rem) clamp(1.25rem, 5vw, 2rem)',
        boxShadow: `0 8px 32px ${theme.colors.glowStrong || 'rgba(56,189,248,0.35)'}`,
        marginBottom: '2rem',
        textAlign: 'center',
      }}>
        <p style={{ color: theme.colors.background, fontSize: '0.95rem', fontWeight: '600', margin: '0 0 0.4rem', textTransform: 'uppercase', letterSpacing: '1px' }}>
          🎉 Oferta especial
        </p>
        <h2 style={{ color: theme.colors.background, fontSize: 'clamp(1.6rem, 6vw, 2.4rem)', fontWeight: '800', margin: 0, lineHeight: 1.2 }}>
          Aprovecha 1 mes GRATIS por crear tu cuenta
        </h2>
        <a
          href="/register"
          style={{
            display: 'inline-block',
            marginTop: '1.4rem',
            backgroundColor: theme.colors.background,
            color: theme.colors.primary,
            textDecoration: 'none',
            fontWeight: '700',
            fontSize: '1rem',
            padding: '0.75rem 2rem',
            borderRadius: '10px',
          }}
        >
          Crear mi cuenta gratis →
        </a>
      </div>

      <div style={{
        backgroundColor: theme.colors.background,
        borderRadius: '10px',
        border: `1px solid ${theme.colors.border}`,
        padding: '1.5rem',
        marginBottom: '2rem',
      }}>
        <h2 style={{ color: theme.colors.primary, fontSize: '1rem', fontWeight: '600', marginBottom: '0.7rem' }}>
          Tu Propia Página Web
        </h2>
        <p style={{ color: theme.colors.text, lineHeight: '1.7', margin: 0, fontSize: '0.9rem' }}>
          Lleva tu negocio a internet con una página web propia lista para tus clientes las 24 horas.
          Agenda <strong style={{ color: theme.colors.primary }}>citas</strong> en línea, vende con un
          <strong style={{ color: theme.colors.primary }}> carrito de compras</strong>, recibe y gestiona los
          <strong style={{ color: theme.colors.primary }}> PQR de tus clientes</strong> con un sistema de tickets ordenado
          y mantén a todos informados publicando tus <strong style={{ color: theme.colors.primary }}>noticias</strong>,
          promociones y novedades. Todo desde un solo lugar y con una inversión mínima.
        </p>
      </div>

      <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '1.5rem',
          marginBottom: '2.5rem',
        }}>
          {FEATURES.map((feature, i) => (
            <div key={i} style={{
              backgroundColor: theme.colors.background,
              borderRadius: '10px',
              border: `1px solid ${theme.colors.border}`,
              padding: '1.5rem',
            }}>
              <h2 style={{ color: theme.colors.primary, fontSize: '1rem', fontWeight: '600', marginBottom: '0.7rem' }}>
                {feature.title}
              </h2>
              <p style={{ color: theme.colors.text, lineHeight: '1.7', margin: 0, fontSize: '0.9rem' }}>
                {feature.content}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: 'clamp(1.5rem, 5vw, 2rem) clamp(1.25rem, 5vw, 2.5rem)',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
        textAlign: 'center',
      }}>
        <h2 style={{ color: theme.colors.primary, fontSize: '1.3rem', marginBottom: '1.2rem' }}>
          Contáctanos
        </h2>
        <p style={{ color: theme.colors.text, marginBottom: '0.6rem', fontSize: '0.95rem' }}>
          ¿Listo para automatizar tu negocio? Escríbenos, con gusto te asesoramos.
        </p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '2.5rem', flexWrap: 'wrap', marginTop: '1.2rem' }}>
          <div>
            <p style={{ color: theme.colors.textMuted, fontSize: '0.8rem', marginBottom: '0.3rem' }}>Correo</p>
            <a
              href="mailto:newhorizontstart@gmail.com"
              style={{ color: theme.colors.primary, textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem' }}
            >
              newhorizontstart@gmail.com
            </a>
          </div>
          <div>
            <p style={{ color: theme.colors.textMuted, fontSize: '0.8rem', marginBottom: '0.3rem' }}>Celular / WhatsApp</p>
            <a
              href="https://wa.me/573006214893"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: theme.colors.primary, textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem' }}
            >
              57 300 621 4893
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Home;
